import { Box } from "@/components/layout/flexbox";
import { MIDTEXT_COLOR } from "@/css/constants";

interface RequestBookingTextProps {
  hasBorder?: boolean;
}

export function RequestBookingText({
  hasBorder = false,
}: RequestBookingTextProps) {
  return (
    <Box mt={2}>
      <Box fontWeight={600}>Select times that work for you</Box>
      <Box fontWeight={"normal"} color={MIDTEXT_COLOR} fontSize={14}>
        The coach will choose from your selected times
      </Box>
      {hasBorder && <Box className="bbs" my={3} />}
    </Box>
  );
}
